import { render, staticRenderFns } from "./CampaignSettings.vue?vue&type=template&id=2224d988&"
import script from "./CampaignSettings.vue?vue&type=script&lang=ts&"
export * from "./CampaignSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports